export default __webpack_public_path__ + "static/media/boy.175a2348.png";